// CSKH links for THIS project (BusDCX). Each project has its own values.
// Override per deployment via .env (VUE_APP_*). Empty value hides the button.
const env = process.env

export const contact = {
  phone: env.VUE_APP_CONTACT_PHONE || '0928382087',
  zalo: env.VUE_APP_ZALO_URL || '',
  messenger: env.VUE_APP_MESSENGER_URL || '',
  facebook: env.VUE_APP_FACEBOOK_URL || '',
  tiktok: env.VUE_APP_TIKTOK_URL || '',
  youtube: env.VUE_APP_YOUTUBE_URL || ''
}

export default contact
